// src/components/reports/InsightsList.tsx
import React from 'react';
import { Box, Chip, Skeleton } from '@mui/material';

const InsightsList: React.FC<{ loading: boolean; insights: string[]; hasData: boolean }> = ({ loading, insights, hasData }) => {
  if (loading) {
    return (
      <Box sx={{ display:'flex', gap:1, flexWrap:'wrap' }}>
        {Array.from({ length: 4 }).map((_,i)=> <Skeleton key={i} width={220} height={32} />)}
      </Box>
    );
  }
  if (!hasData) return <Box sx={{ opacity:.7 }}>No data for this month.</Box>;
  if (!insights.length) return <Box sx={{ opacity:.7 }}>No notable changes detected.</Box>;

  return (
    <Box sx={{ display:'flex', gap:1, flexWrap:'wrap' }}>
      {insights.map((t, i) => <Chip key={i} label={t} />)}
    </Box>
  );
};

export default InsightsList;
